import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {

  constructor() { }  

  /**
   * 
   * @param field AbstractControl
   * @param type string
   * @returns boolean
   */
  validation(field: AbstractControl, type: string): boolean {

    return field.invalid && (field.dirty || field.touched) && field.hasError(type);
  }


  /**
   * 
   * @param field AbstractControl
   * @returns 'is-invalid' | 'is-valid'
   */
  checkingFieldStatus(field: AbstractControl): 'is-invalid' | 'is-valid' { 

    if(field.invalid && (field.dirty || field.touched)){

      return 'is-invalid';
    }

    return 'is-valid';
  }


  /**
   * 
   * @param controlName 
   * @param matchingControlName 
   */
  mustMatch(controlName: string, matchingControlName: string) {
        
    return (formGroup: UntypedFormGroup) => {

      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      // return if another validator has already found an error on the matchingControl
      if(matchingControl.errors && !matchingControl.errors.mustMatch){
          
          return;
      }

      // set error on matchingControl if validation fails
      if(control.value !== matchingControl.value){

          matchingControl.setErrors({ mustMatch: true });
      } 
      else {
          
          matchingControl.setErrors(null);
      }
    }
  }
}
